module.exports = __webpack_public_path__ + "img/icon-61.7838acd5.png";